import { BaseError } from './BaseError';

/**
 * API-specific error class for handling server responses and network issues
 */
export class ApiError extends BaseError {
  constructor(
    message: string,
    public readonly code: number = 500,
    options: {
      isOperational?: boolean;
      cause?: Error;
      context?: Record<string, unknown>;
    } = {}
  ) {
    super(message, {
      name: 'ApiError',
      isOperational: options.isOperational !== undefined ? options.isOperational : true,
      cause: options.cause,
      context: {
        statusCode: code,
        ...options.context,
      },
    });
  }

  /**
   * Standardized JSON representation including API-specific details
   */
  public override toJSON(): Record<string, unknown> {
    const baseJson = super.toJSON();
    return {
      ...baseJson,
      code: this.code,
    };
  }
}
